import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

import { UiKitRatingBlock } from '@/fo/ui/kit/rating/block';

import { Review, ReviewService } from '../../types';
import { ReviewContentBlock } from '../ReviewContentBlock/ReviewContentBlock';
import { ReviewResponseCard } from '../ReviewResponseCard/ReviewResponseCard';

import { styles } from './ReviewCard.styles';

export interface ReviewCardProps {
  review: Review;
}

export function ReviewCard({ review }: ReviewCardProps) {
  const t = useTranslations();
  const slots = styles();

  const serviceIconsMap: Record<ReviewService, ReactNode> = {};

  return (
    <div className={slots.base()}>
      <div className={slots.header()}>
        <UiKitRatingBlock
          value={review.rating}
          withValue={false}
        />
      </div>
      <div className={slots.subHeader()}>
        <div className={slots.author()}>
          <span>{review.author.name || t('review.authorPlaceholder')}</span>
          <span className={slots.date()}>{review.date}</span>
        </div>
      </div>

      <div className={slots.content()}>
        <ReviewContentBlock
          title={t('review.labels.pros')}
          content={review.pros}
        />

        <ReviewContentBlock
          title={t('review.labels.cons')}
          content={review.cons}
        />

        <ReviewContentBlock
          title={t('review.labels.comment')}
          content={review.comment}
        />
      </div>

      {review.response && (
        <ReviewResponseCard
          text={review.response.text}
          recommendedProduct={review.response.recommendedProduct}
        />
      )}

      {review.source && (
        <a
          href={review.source.url}
          target="_blank"
          rel="noopener noreferrer"
          className={slots.sourceLink()}
        >
          {serviceIconsMap[review.source.type]}
        </a>
      )}
    </div>
  );
}
